module.exports = __webpack_public_path__ + "static/certified-organic-353e23d5c848c5a3f1dc36734bf37f22.jpg";